module.exports = __webpack_public_path__ + "assets/img/3_1229_big.70b1dead.jpg";